import { render } from "./LeituraPessoajuridica.vue?vue&type=template&id=094cb946"
import script from "./LeituraPessoajuridica.vue?vue&type=script&lang=js"
export * from "./LeituraPessoajuridica.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__